<template>
  <div>
    <b-modal :model-value="showDialogEdit">
        <div>{{labels.information}}</div> 
        <div>
            <b-col md="8" lg="12" class="p-4 mx-auto">
            <b-form-group @submit.prevent="editInfoProvider"> 
                <label>{{labels.concept}} </label> 
                <input type="text" v-model="ItemProva.concept"> 
                <label>{{labels.documentType}} </label> 
                <input type="text" v-model="ItemProva.documentType"> 
                <label>{{labels.identificationNumber}} </label> 
                <input type="text" v-model="ItemProva.nii"> 
                <label>{{labels.name}} </label> 
                <input type="text" v-model="ItemProva.name"> 
                <label>{{labels.address}} </label> 
                <input type="text" v-model="ItemProva.address"> 
                <label>{{labels.departmentCode}} </label> 
                <input type="text" v-model="ItemProva.departmentCode"> 
                <label>{{labels.nameDepartment}} </label> 
                <input type="text" v-model="ItemProva.departmentName"> 
                <label>{{labels.mcpCode}} </label> 
                <input type="text" v-model="ItemProva.mcpCode"> 
                <label>{{labels.mcpName}} </label> 
                <input type="text" v-model="ItemProva.mcpName"> 
                <label>{{labels.country}} </label> 
                <input type="text" v-model="ItemProva.country"> 
                <label>{{labels.dateSarlaf}}</label> 
                    <input type="date" v-model="fechaSarlaf">
                <label>{{labels.retefuenteOne}}</label> 
                    <input type="text" v-model="ItemProva.retefuente1"> 
                <label>{{labels.nameRetefuenteOne}}</label> 
                    <input type="text" v-model="ItemProva.nameRetefuente1"> 
                <label>{{labels.retefuenteTwo}}</label> 
                    <input type="text" v-model="ItemProva.retefuente2"> 
                <label>{{labels.nameRetefuenteTwo}}</label> 
                    <input type="text" v-model="ItemProva.nameRetefuente2"> 
                <label>{{labels.reteiva}}</label> 
                    <input type="text" v-model="ItemProva.reteiva"> 
                <label>{{labels.reteicaOne}}</label> 
                    <input type="text" v-model="ItemProva.reteica1"> 
                <label>{{labels.nameReteicaOne}}</label> 
                    <input type="text" v-model="ItemProva.nameReteica1"> 
                <label>{{labels.reteicaTwo}}</label> 
                    <input type="text" v-model="ItemProva.reteica2"> 
                <label>{{labels.nameReteicaTwo}}</label> 
                    <input type="text" v-model="ItemProva.nameReteica2"> 
                <label>{{labels.codTributaOne}}</label> 
                    <input type="text" v-model="ItemProva.tributa1"> 
                <label>{{labels.nameTributaOne}}</label> 
                    <input type="text" v-model="ItemProva.nameTributa1"> 
                <label>{{labels.codTributaTwo}}</label> 
                    <input type="text" v-model="ItemProva.tributa2"> 
                <label>{{labels.nameTributaTwo}}</label> 
                    <input type="text" v-model="ItemProva.nameTributa2"> 
                <label>{{labels.codTributaThree}}</label> 
                    <input type="text" v-model="ItemProva.tributa3"> 
                <label>{{labels.nameTributaThree}}</label> 
                    <input type="text" v-model="ItemProva.nameTributa3"> 
                <label>{{labels.codTributaFour}}</label> 
                    <input type="text" v-model="ItemProva.tributa4"> 
                <label>{{labels.nameTributaFour}}</label> 
                    <input type="text" v-model="ItemProva.nameTributa4"> 
                <label>{{labels.codTributaFive}}</label> 
                    <input type="text" v-model="ItemProva.tributa5"> 
                <label>{{labels.nameTributaFive}}</label> 
                    <input type="text" v-model="ItemProva.nameTributa5"> 
                <label>{{labels.codTributaSix}}</label> 
                    <input type="text" v-model="ItemProva.tributa6"> 
                <label>{{labels.nameTributaSix}}</label> 
                    <input type="text" v-model="ItemProva.nameTributa6"> 
                <label>{{labels.rtefteOne}}</label> 
                    <input type="text" v-model="ItemProva.rtefte1"> 
                <label>{{labels.rtefteTwo}}</label> 
                    <input type="text" v-model="ItemProva.rtefte2"> 
                <label>{{labels.icaOne}}</label> 
                    <input type="text" v-model="ItemProva.ica1"> 
                <label>{{labels.icaTwo}}</label> 
                    <input type="text" v-model="ItemProva.ica2"> 
                
            </b-form-group>
            <div>
                <b-button class="md-primary" @click="editInfoProvider(ItemProva)">Guardar</b-button>
                <b-button class="md-accent" @click="showDialogEdit = false">Cerrar</b-button>
            </div>
            </b-col>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Provider from "@/services/Provider"; 
export default {
    name: 'Edita',
    props:['showDialogEdit','ItemProva'],
    data(){
        return{
            isLoading:false,
            concepto: '',
            tipoDocumento: '',
            razonSocial: '',
            direccion: '',
            codDepto: '',
            nombreDepto: '',
            codmcp: '',
            nombremcp: '',
            pais: '',
            fechaSarlaf: '',
            retefuenteUno: '',
            nombreRetefuenteUno: '',
            retefuenteDos: '',
            nombreRetefuenteDos: '',
            reteiva: '',
            reteicaUno: '',
            nombreReteicaUno: '',
            reteicaDos: '',
            nombreReteicaDos: '',
            codTributaUno: '',
            nombreTributaUno: '',
            codTributaDos: '',
            nombreTributaDos: '',
            codTributaTres: '',
            nombreTributaTres: '',
            codTributaCuatro: '',
            nombreTributaCuatro: '',
            codTributaCinco: '',
            nombreTributaCinco: '',
            codTributaSeis: '',
            nombreTributaSeis: '',
            rtefteUno: '',
            rtefteDos: '',
            icaUno: '',
            icaDos: '',
        }
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                information: "Información del Proveedor",
                concept: "Concepto",
                documentType: "Tipo de documento",
                identificationNumber: "Número identificación",
                name: "Razón social",
                address: "Dirección",
                departmentCode: "Código del departamento",
                nameDepartment: "Nombre del departamento",
                mcpCode: "Código mcp",
                mcpName: "Nombre mcp",
                country: "País de residencia o domicilio",
                dateSarlaf: "Fecha Sarlaft",
                retefuenteOne: "Retefuente (1)",
                nameRetefuenteOne: "Nombre retefuente (1)",
                retefuenteTwo: "Retefuente (2)",
                nameRetefuenteTwo: "Nombre retefuente (2)",
                reteiva: "Reteiva",
                reteicaOne: "Reteica (1)",
                nameReteicaOne: "Nombre reteica (1)",
                reteicaTwo: "Reteica (2)",
                nameReteicaTwo: "Nombre reteica (2)",
                codTributaOne: "Cod. tributa (1)", 
                nameTributaOne: "Nombre cod. tributa (1)", 
                codTributaTwo: "Cod. tributa (2)", 
                nameTributaTwo: "Nombre cod. tributa (2)", 
                codTributaThree: "Cod. tributa (3)", 
                nameTributaThree: "Nombre cod. tributa (3)", 
                codTributaFour: "Cod. tributa (4)", 
                nameTributaFour: "Nombre cod. tributa (4)", 
                codTributaFive: "Cod. tributa (5)", 
                nameTributaFive: "Nombre cod. tributa (5)", 
                codTributaSix: "Cod. tributa (6)", 
                nameTributaSix: "Nombre cod. tributa (6)", 
                rtefteOne: "Rtefte (1)",
                rtefteTwo: "Rtefte (2)",
                icaOne: "Ica (1)",
                icaTwo: "Ica (2)",
                }
            }else {
                return {
                information: "Provider information",
                concept: "Concept",
                documentType: "Document type",
                identificationNumber: "Identification number",
                name: "Business name",
                address: "Address",
                departmentCode: "Department code",
                nameDepartment: "Department name",
                mcpCode: "mcp code",
                mcpName: "mcp name",
                country: "Country of residence or domicile",
                dateSarlaf: "Date Sarlaft",
                retefuenteOne: "Retefuente (1)",
                nameRetefuenteOne: "Retefuente name (1)",
                retefuenteTwo: "Retefuente (2)",
                nameRetefuenteTwo: "Retefuente name (2)",
                reteiva: "Reteiva",
                reteicaOne: "Reteica (1)",
                nameReteicaOne: "Reteica name (1)",
                reteicaTwo: "Reteica (2)",
                nameReteicaTwo: "Reteica name (2)",
                codTributaOne: "Tributa code (1)",
                nameTributaOne: "Tributa name (1)",
                codTributaTwo: "Tributa code (2)",
                nameTributaTwo: "Tributa name (2)",
                codTributaThree: "Tributa code (3)",
                nameTributaThree: "Tributa name (3)",
                codTributaFour: "Tributa code (4)",
                nameTributaFour: "Tributa name (4)",
                codTributaFive: "Tributa code (5)",
                nameTributaFive: "Tributa name (5)",
                codTributaSix: "Tributa code (6)",
                nameTributaSix: "Tributa name (6)",
                rtefteOne: "Rtefte (1)",
                rtefteTwo: "Rtefte (2)",
                icaOne: "Ica (1)",
                icaTwo: "Ica (2)",
                }
            }
        }
    },
    methods: {
        editInfoProvider(ItemProva){
            // console.log(ItemProva) 
            
            Provider.updateProvider(ItemProva) 
            .then(() => { 
                this.isLoading = true;
                this.$toast.success("Proveedor editado correctamente")
                location. reload() 
            })
            .catch((error) => { 
                console.log(error) 
            })
            .finally(() => { 
                this.isLoading = false;
            })
        }
    }
}
</script>
<style src="../main.css"> 
</style>
